/*
 *   File : secondary.js
 *   Author : https://evoqueinnovativelab.com
 *   Description : Primary Button
 *   Integrations : null
 *   Version : 1.0.0
 *   Created : 06-12-2021
 */

/*import style*/
import styles from '../../styles/components/secondary.module.scss';

const SecondaryBtn = (props) => {
	return (
		<button id={props.id}
			className={props.disabled ? `e-input-wrap ${styles.e_s_btn} ${styles.e_disabled} ${props.className}` : `e-input-wrap ${styles.e_s_btn} ${props.className}`}
			data-bs-dismiss={props.cancel}
			data-bs-toggle={props.toggle}
			data-bs-target={props.target}
			onClick={props.handleClick}
			type={props.type ? props.type : "submit"}
		>
			{
				props.left && (
					<img src={props.image} className={props.iconClass}/>
				)
			}
			<span>{props.name}</span>
			{
				props.right && (
					<img src={props.image} className={props.iconClass}/>
				)
			}
		</button>
	);
}

export default SecondaryBtn;